export const ApiEndpoints = {
  memberships: '/memberships/my',
  kauferPlusLegalInsurance: '/legal-insurance/my',
  kauferPlusLegalInsuranceDownload: '/legal-insurance/my/download',
  userInteractions: '/user-interactions/my?page=BENEFITS_PAGE',
  featureSwitches: '/konto/api/client/feature-switch',
  schufaStatus: '/konto/api/client/document/schufa',
  is24SolvencyStatus: '/konto/api/client/document/is24solvency',
  userAccount: '/konto/api/client/user-account',
  startBillCheck: '/konto/api/client/billcheck/v3/start',
  billCheckDetails: '/konto/api/client/billcheck/v3/details/',
  generateSignedDocumentUploadUrl: '/konto/api/client/billcheck/v3/document-upload-urls/',
  submitBillCheck: '/konto/api/client/billcheck/v3/submit/',
  solvencyInfo: '/konto/api/client/solvency/info',
  addressChange: '/konto/api/client/products/address-change',
  insuranceDetails: '/konto/api/client/livingplus/insurance',
  validateToken: '/konto/api/client/secured/validate-token',
  magentaDiscount: '/konto/api/client/magenta/discount',
  creditHistory: '/v1/plus-benefits/credit-history',
  landlordInfo: (objectId: string) => `/konto/api/client/tenant/${objectId}/landlord-info`,
  tenantDocuments: (objectId: string) => `/konto/api/client/tenant/${objectId}/document`,
  tenantDocument: (objectId: string, documentId: string) =>
    `/konto/api/client/tenant/${objectId}/document/${documentId}`,
  upsellOffer: '/konto/api/client/upsell',
  upsellPurchase: '/konto/api/client/upsell/purchases',
  upsellPurchaseResult: (transactionId: string) => `/konto/api/client/upsell/purchases/${transactionId}`,
  voucherGenerate: '/konto/api/client/voucher/generate',
  freeExtensionCancellation: '/konto/api/client/suchenplus/contract/free-extension-cancellation',
};
